<template>
	<div class="boothStaff-wrapper mt-2" :style="{ backgroundColor }">
		<div class="boothStaff-card">
			<div class="boothStaff-card__logo">
				<Avatar :size="60" :avatar="boothStaff.user_logo" />
			</div>
			<div class="boothStaff-card__info">
				<div class="boothStaff-card__title">{{ boothStaff.visible_username }}</div>
				<div class="boothStaff-card__second-title">
					{{ boothStaff.second_profile_row }}
				</div>
				<div class="boothStaff-card__third-title">
					{{ boothStaff.third_profile_row }}
				</div>
				<div v-if="mailTo" class="boothStaff-card__subtitle">
					<Icon type="pin" :size="16" color="var(--accent-color)" />
					<span class="boothStaff-card__location-value"> </span>
				</div>
			</div>
			<div class="boothStaff-card__bookmark">
				<div v-if="boothStaff.userFlag === 1" class="boothStaff-card__employee-banner">
					Best employee
				</div>
				<Icon v-if="mailTo" type="messages-both" :size="24" color="var(--accent-color)" />
			</div>
		</div>
	</div>
</template>

<script>
import Avatar from '@/components/Avatar'
import Icon from '@/components/Icon'

export default {
	name: 'BootStaffCard',
	components: {
		Avatar,
		Icon,
	},
	data() {
		return {
			mailTo: false,
			address: null,
		}
	},
	props: {
		boothStaff: {
			type: Object,
			required: true,
		},
		backgroundColor: {
			type: String,
			default: '',
		},
	},
	methods: {},
	mounted() {},
}
</script>

<style lang="scss">
.boothStaff-wrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 16px;
	border-radius: 10px;
}

.boothStaff-card {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	position: relative;
}

.boothStaff-card__logo {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 60px;
	height: 60px;
	border-radius: 50%;
	overflow: hidden;
}

.boothStaff-card__info {
	flex: 1;
	margin-left: 16px;

	.boothStaff-card__title {
		font-size: 16px;
		font-weight: 700;
		color: #002855;
		margin-bottom: 4px;
		font-family: Montserrat, sans-serif;
	}

	.boothStaff-card__second-title,
	.boothStaff-card__third-title {
		font-size: 13px;
		font-weight: 400;
		color: #4a4a4a;
		line-height: 1.5;
		font-family: Montserrat, sans-serif;
	}

	.boothStaff-card__subtitle {
		display: flex;
		align-items: center;
		margin-top: 8px;

		svg {
			margin-right: 4px;
		}

		.boothStaff-card__location-value {
			font-size: 13px;
			font-weight: 500;
			color: var(--accent-color);
		}
	}
}

.boothStaff-card__bookmark {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
}

.boothStaff-card__employee-banner {
	position: absolute;
	width: 115px;
	max-height: 22px;
	top: -16px;
	right: -16px;
	background-color: #4f89d5;
	color: #ffffff;
	font-size: 12px;
	font-weight: 700;
	padding: 2px 12px;
	border-radius: 0 10px 0 0;
	white-space: nowrap;
	font-family: Montserrat, sans-serif;

	&::before {
		content: '';
		position: absolute;
		left: -8px;
		top: 0;
		width: 0;
		height: 0;
		border-style: solid;
		border-width: 22px 18px 0 8px;
		border-color: #4f89d5 transparent transparent transparent;
	}
}
</style>
